import { render, staticRenderFns } from "./ModalNovoDocumento.vue?vue&type=template&id=dad8e312&scoped=true"
import script from "./ModalNovoDocumento.vue?vue&type=script&lang=js"
export * from "./ModalNovoDocumento.vue?vue&type=script&lang=js"
import style0 from "./ModalNovoDocumento.vue?vue&type=style&index=0&id=dad8e312&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad8e312",
  null
  
)

export default component.exports